import React from "react";

export default function fileManagement({ color = "white" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="19" viewBox="0 0 17 19">
      <path
        fill={color}
        fillRule="evenodd"
        d="M5.136 17.118h9.415V5.135H5.136v11.983zm9.415-13.695H5.135c-.946 0-1.711.766-1.711 1.712v11.983a1.71 1.71 0 0 0 1.711 1.711h9.416a1.71 1.71 0 0 0 1.711-1.711V5.135c0-.946-.765-1.712-1.711-1.712zM11.983 0H1.71A1.71 1.71 0 0 0 0 1.711v11.983h1.711V1.711h10.272V0z"
      />
    </svg>
  );
}
